import { OrderApi } from '../api/OrderApi'
import { Order } from '../core/Order'
import { plansStore } from '../store/plansStore'
import { menuStore } from '../store/menuStore'
import { orderStore } from '../store/orderStore'
import { errorStore } from '../store/errorStore'
import { GatewayCheckout } from '../services/GatewayCheckout'

export const orderAction = {
	data () {
		return {
			loadingOrder: false,
			plansStore: plansStore.state,
			menuStore: menuStore.state,
			errorStore: errorStore.state,
		}
	},
	computed: {
		maxRecipes () {
			return plansStore.getMaxRecipes({ plan_id: this.plansStore.selectedPlanId })
		},

		minRecipes () {
			return plansStore.getMinRecipes({ plan_id: this.plansStore.selectedPlanId })
		},
		canConfirm () {
			return this.order && !this.errorStore.message
		},
		user () {
			return this.$root.user
		},
		order () {
			return this.user ? this.user.order : null
		},
		menu () {
			return this.menuStore.menu
		},
		recipesDet () {
			let recipes = {};

			if (!this.order) {
				return recipes;
			}

			for (let r in this.order.recipes) {
				r = this.order.recipes[r]
				recipes[r.id] = { id: r.id, quantity: r.quantity }
			}

			return recipes;
		},
		recipes () {
			return this.order ? this.order.recipes : []
		},
		extras () {
			return this.order ? this.order.extras : []
		},
		parameterExtras () {
			let extras = [];

			if (!this.order) {
				return extras;
			}

			for (let r in this.order.extras) {
				r = this.order.extras[r]
				extras.push({ id: r.id, quantity: r.quantity })
			}

			return extras;
		}
	},
	mounted() {
		// menuStore.loadCurrentMenu();
		// plansStore.loadPlans();
	},
	methods: {

		isRecipeInBox (recipe) {
			return this.$_orderAction_getRecipeIndex(recipe) >= 0
		},

		$_orderAction_maxReached() {

			if (!this.plansStore.plans) return false;

			var max = plansStore.getMaxRecipes({ plan_id: this.plansStore.plans.find(plan => this.order && this.order.plan ? this.order.plan.people : 2 === plan.people).id})
			var max = plansStore.getMaxRecipes({ plan_id: this.plansStore.plans.find(plan => (this.order && this.order.plan ? this.order.plan.people : 2) === plan.people).id})

			var c = Object.values(this.order ? this.order.recipes : 0).map(a => a.quantity).reduce((a, b) => a + b, 0)

			return c+1 > max

		},

		$_orderAction_isOneMoreRecipeAvailableBySingle (needle) {

			if (!this.order) {
				return 0
			}

			if (this.$_orderAction_maxReached()) {
				return 0
			}	

			var menuRecipe = this.menu.recipes.find(recipe => {
				return recipe.id === needle.id;
			})
			
			return menuRecipe ? menuRecipe.availability - this.$_orderAction_getRecipeQuantity(needle) > 0 : false;
		},


		$_orderAction_isOneMoreRecipeAvailable (needle) {

			if (!this.order) {
				return 0
			}

			if (this.$_orderAction_maxReached()) {
				return 0
			}	

			var menuRecipe = this.menu.recipes.find(recipe => {
				return recipe.id === needle.id;
			})
			
			return menuRecipe ? menuRecipe.availability_all[this.order.plan.people] - this.$_orderAction_getRecipeQuantity(needle) > 0 : false;
		},


		$_orderAction_getExtraIndex(needle) {
			return this.order ? this.order.extras.findIndex(extra => {
				return extra.id === needle.id;
			}) : -1
		},

    $_orderAction_changeExtra (extra, quantity) {

      var order = this.order

			let index = this.$_orderAction_getExtraIndex(extra);
      
      if (quantity == 0) {
				this.order.extras.splice(index, 1)
				return;
      }

			if (index === -1) {
				extra.quantity = quantity
				this.order.extras.push(extra)
			} else {
				this.order.extras[index].quantity = quantity
			}

    },

    $_orderAction_addExtra (extra, quantity) {
			let callback = () => {
				return this.$_orderAction_addExtraInner(extra, quantity)
			}
			if (!GatewayCheckout.isGuestAllowed(callback)) {
				return;
			}
			return callback()
		},

		$_orderAction_addExtraInner(extra, quantity) {

      var params = { __preserve: 0 }
      var order = this.order
      var e = order.getExtraByAttribute('id', extra.id)

      if (extra.stock <= 0) return

      if (!Array.isArray(order.extras)) {
        order.extras = Object.values(order.extras)
      }


      if (!e) { order.extras.push({id: extra.id, quantity: 1}) } else { e.quantity = typeof quantity != "undefined" ? parseInt(quantity) : e.quantity+1  }


      params.extra = order.extras.map(function (v) {
        return { id: v.id, quantity: v.quantity }
      })



      return this.$_orderAction_updateOrder({ params: params }).catch(response => {
        if (e) { e.quantity-- }
      })
    },

		$_orderAction_removeRecipe (recipe) {
			return this.$_orderAction_updateRecipe(recipe, this.$_orderAction_getRecipeQuantity(recipe) - 1);
		},

		$_orderAction_addRecipe (recipe) {
			return this.$_orderAction_updateRecipe(recipe, this.$_orderAction_getRecipeQuantity(recipe) + 1);
		},

		$_orderAction_getRecipe (needle) {
			return this.order ? this.order.recipes.find(recipe => {
				return recipe.id === needle.id;
			}) : null
		},
		$_orderAction_getRecipeIndex (needle) {
			return this.order ? this.order.recipes.findIndex(recipe => {
				return recipe.id === needle.id;
			}) : -1
		},

		$_orderAction_getRecipeQuantity (recipe) {
			let orderRecipe = this.$_orderAction_getRecipe(recipe);

			return orderRecipe ? orderRecipe.quantity : 0;
		},

		$_orderAction_unsetOrderRecipe(recipe) {
			let index = this.$_orderAction_getRecipeIndex(recipe);

			if (index >= 0) {
				this.order.recipes.splice(index, 1)
			}
		},

		$_orderAction_setOrderRecipe(recipe, quantity) {

			if (quantity == 0) {
				return this.$_orderAction_unsetOrderRecipe(recipe)
			}

			let index = this.$_orderAction_getRecipeIndex(recipe);

			if (index === -1) {
				recipe.quantity = quantity
				this.order.recipes.push(recipe)
			} else {
				this.order.recipes[index].quantity = quantity
			}
		},
		$_orderAction_getQuantityOrderRecipe(recipe) {

			let index = this.$_orderAction_getRecipeIndex(recipe);

			if (index === -1) {
				return 0;
			} else {
				return this.order.recipes[index].quantity
			}
		},

		$_orderAction_changeQuantityOrderRecipe(recipe, quantity, order) {

			window.dispatchEvent(new CustomEvent('quomi.event', { 
		        bubbles: true, 
		        detail: {
		          name: 'updateProductQuantity',
		          vars: {
		          	product: recipe.product,
		          	quantity: quantity - this.$_orderAction_getQuantityOrderRecipe(recipe),
		          	order: order
		          }
		        } 
		     }));

			if (quantity <= 0) {
				this.$_orderAction_unsetOrderRecipe(recipe);
			} else if (quantity > 0) {
				this.$_orderAction_setOrderRecipe(recipe, quantity);
			}
		},

		$_orderAction_updateRecipe (recipe, quantity, preserve) {
			let callback = () => {
				var order = this.order
				this.$_orderAction_changeQuantityOrderRecipe(recipe, quantity, order);
				return this.$_orderAction_updateCurrentRecipes(preserve)
			}

			if (!GatewayCheckout.isGuestAllowed(callback)) {
				this.$emit('update:updating', false)
				return Promise.resolve(1);
			}

			return callback()
		},

		$_orderAction_updateCurrentRecipes(preserve) {

			if (typeof preserve === 'undefined') {
				preserve = 1
			}

			var params = { __preserve: preserve }

			params.recipes_id = this.recipesDet;

			params.extra = this.parameterExtras
			window.orderRawPlan = null;

			return plansStore.loadPlans().then(i => {
				return plansStore.findPlan({
					people: this.order.plan.people,
					meals: Object.values(params.recipes_id).map(a => a.quantity).reduce((a, b) => a + b, 0)
				})
			}).then(plan => {

				params.plan_id = plan.id
				window.orderRawPlan = plan;

				orderStore.updateOrderParam({ param: 'plan_id', value: params.plan_id })
	      orderStore.updateOrderParam({ param: 'recipes_id', value: params.recipes_id })
				orderStore.updateOrderParam({ param: 'extra', value: params.extra })


				return this.$_orderAction_updateOrder({ params: params })
			}).catch(e => {
				if (e.message != 'invalid meals quantity') {
					throw e
				}
			})
		},

		$_orderAction_updateOrder (vars) {
			this.$emit('update:updating', true)
			if (!this.order) return Promise.resolve()
			var token = this.order.token
			var params = vars ? vars.params : {}
			var om = new OrderApi()

			if (params.extra) {
				orderStore.updateOrderParam({ param: 'extra', value: params.extra })
			}
			
			this.$emit('changed')

			let t = Promise.resolve();

			return t.then(() => {
				return om.updateOrCreate(token, params)
			}).then(response => {
				var order = new Order(response.body.data.resource)
				//this.$emit('update:order', order)
	
				window.order = order

				var user = this.user
				user.order = order
				this.$root.updateUser(user)
				orderStore.saveOrderToStore(response)
			}).finally(response => {
				this.$emit('update:updating', false)
			})
		}
	}
}
